import React, { Component } from "react";
import { Card, Icon, Tag, Row, Col, Avatar, List, Radio, Button } from "antd";
import F from "../../../Functions";
import WizardFooter from "./wizard-footer";
import Print from "./print-liability";
import { Translate } from "react-translated";

import Home from "./images/bfile-homeowners.svg";
import SecondaryHome from "./images/bfile-homeowners.svg";
import MFGHome from "./images/bfile-mfg.svg";
import Renter from "./images/bfile-renter.svg";
import Condominium from "./images/bfile-condominium.svg";
import Landlord from "./images/bfile-landlord.svg";
import VacantProperty from "./images/bfile-vacant-land.svg";
import Umbrella from "./images/bfile-umbrella.svg";
import Umbrellas from "./images/Umbrella.png";
import Bike from "./images/bike.png";
import House from "./images/house.png";
import Car from "./images/car.png";
import Bfilelogo from "./images/bfile-logo.png";
// import Thumb from "./images/bfile-thumb.jpg";
import Auto from "./images/bfile-classic_car.svg";
import ClassicCar from "./images/bfile-classic_car.svg";
import RV from "./images/bfile-rv.svg";
import Boat from "./images/bfile-boat.svg";
import Motorcycle from "./images/bfile-motorcycle.svg";
import Drone from "./images/icon-drone.svg";
import GolfCart from "./images/bfile-golf_cart.svg";
import Watercraft from "./images/bfile-watercraft.svg";
import Snowmobile from "./images/bfile-snowmobile.svg";
import OffRoad from "./images/bfile-offroad.svg";

const RadioGroup = Radio.Group;

class Step extends Component {
  getUmbrellaMessage = () => {
    if (
      this.props.wizard.carrier !== null &&
      this.props.wizard.carrier !== "Farm Bureau"
    ) {
      return "Your recommended limit is $500,000/$1,000,000 on your auto and $500,000 on your home. However, we recommend a 1-million-dollar umbrella with our minimum required underlying limits of $250,000/$500,000 for the auto and $300,000 on your home. That will protect your assets and also give you broader coverage.";
    } else {
      return "";
    }
  };

  render() {
    const { wizard, updateField } = this.props;

    let recommended_limit = "";
    let recommended_limit_2 = "";
    let umbrella_message = "";

    if (wizard.rac_calculator >= 0 && wizard.rac_calculator <= 24999) {
      recommended_limit = "$25,000/$50,000";
      recommended_limit_2 = "$100,000";
      wizard.umbrella_limit = "";
    }
    if (wizard.rac_calculator >= 25000 && wizard.rac_calculator <= 49999) {
      recommended_limit = "$50,000/$100,000";
      recommended_limit_2 = "$100,000";
      wizard.umbrella_limit = "";
    }
    if (wizard.rac_calculator >= 50000 && wizard.rac_calculator <= 99999) {
      recommended_limit = "$100,000/$300,000";
      recommended_limit_2 = "$100,000";
      wizard.umbrella_limit = "";
    }
    if (wizard.rac_calculator >= 100000 && wizard.rac_calculator <= 249999) {
      recommended_limit = "$250,000/$500,000";
      recommended_limit_2 = "$300,000";
      wizard.umbrella_limit = "";
    }
    if (wizard.rac_calculator >= 250000 && wizard.rac_calculator <= 499999) {
      recommended_limit = "$500,000/$1,000,000";
      recommended_limit_2 = "$500,000";
      wizard.umbrella_limit = 1000000;
      umbrella_message = this.getUmbrellaMessage();
    }
    if (wizard.rac_calculator >= 500000 && wizard.rac_calculator <= 1249999) {
      recommended_limit = "$250,000/$500,000";
      recommended_limit_2 = "$300,000";
      wizard.umbrella_limit = 1000000;
    }
    if (wizard.rac_calculator >= 1250000) {
      recommended_limit = "$250,000/$500,000";
      recommended_limit_2 = "$300,000";
      wizard.umbrella_limit = 2000000;
    }
    if (wizard.rac_calculator >= 1250000 && wizard.rac_calculator <= 2249999) {
      wizard.umbrella_limit = 2000000;
    }
    if (wizard.rac_calculator >= 2250000 && wizard.rac_calculator <= 3249999) {
      wizard.umbrella_limit = 3000000;
    }
    if (wizard.rac_calculator >= 3250000 && wizard.rac_calculator <= 4249999) {
      wizard.umbrella_limit = 4000000;
    }
    if (wizard.rac_calculator >= 4250000 && wizard.rac_calculator <= 5249999) {
      wizard.umbrella_limit = 5000000;
    }
    if (wizard.rac_calculator >= 5250000 && wizard.rac_calculator <= 6249999) {
      wizard.umbrella_limit = 6000000;
    }
    if (wizard.rac_calculator >= 6250000 && wizard.rac_calculator <= 7249999) {
      wizard.umbrella_limit = 7000000;
    }
    if (wizard.rac_calculator >= 7250000 && wizard.rac_calculator <= 8249999) {
      wizard.umbrella_limit = 8000000;
    }
    if (wizard.rac_calculator >= 8250000 && wizard.rac_calculator <= 9249999) {
      wizard.umbrella_limit = 9000000;
    }
    if (wizard.rac_calculator >= 9250000) {
      wizard.umbrella_limit = 10000000;
    }

    wizard.auto_policy_recommended_limit = recommended_limit;
    wizard.home_policy_recommended_limit = recommended_limit_2;

    let home_list = [];
    let auto_list = [];
    let umbrella_list = [];

    home_list.push({ title: "Home", icon: Home, value: recommended_limit_2 });

    let name = null;
    let icon = null;
    let value = null;

    if (wizard.secondary_home_type) {
      const secondary_home_type = JSON.parse(wizard.secondary_home_type);
      if (secondary_home_type) {
        for (let i = 0, len = secondary_home_type.length; i < len; i++) {
          name = secondary_home_type[i];
          icon = null;

          if (name === "Secondary Home") icon = SecondaryHome;
          if (name === "MFG Home") icon = MFGHome;
          if (name === "Renter") icon = Renter;
          if (name === "Condominium") icon = Condominium;
          if (name === "Landlord") icon = Landlord;
          if (name === "Vacant Property") icon = VacantProperty;

          home_list.push({
            title: name,
            icon: icon,
            value: recommended_limit_2,
          });
        }
      }
    }

    auto_list.push({ title: "Auto", icon: Auto, value: recommended_limit });

    if (wizard.umbrella_limit !== "") {
      umbrella_list.push({
        title: "Umbrella",
        icon: Umbrella,
        value: wizard.umbrella_limit,
        message: umbrella_message,
      });
    }

    if (wizard.secondary_vehicles) {
      const secondary_vehicles = JSON.parse(wizard.secondary_vehicles);
      if (secondary_vehicles) {
        for (let i = 0, len = secondary_vehicles.length; i < len; i++) {
          name = secondary_vehicles[i];
          icon = null;
          if (name === "Classic Car") {
            icon = ClassicCar;
            value = recommended_limit;
          }
          if (name === "RV") {
            icon = RV;
            value = recommended_limit;
          }
          if (name === "Boat") {
            icon = Boat;
            value = recommended_limit_2;
          }
          if (name === "Motorcycle") {
            icon = Motorcycle;
            value = recommended_limit;
          }
          if (name === "Drone") {
            icon = Drone;
            value = recommended_limit;
          }
          if (name === "Golf Cart") {
            icon = GolfCart;
            value = recommended_limit;
          }
          if (name === "Watercraft") {
            icon = Watercraft;
            value = recommended_limit_2;
          }
          if (name === "Snowmobile") {
            icon = Snowmobile;
            value = recommended_limit;
          }
          if (name === "Off Road") {
            icon = OffRoad;
            value = recommended_limit;
          }
          auto_list.push({ title: name, icon: icon, value: value });
        }
      }
    }
    const style = { backgroundImage: "url(./images/bg.webp)" };
    return (
      <div id="liabilityCard">
        <div className="show-print">
          <table className="user-data" cellpadding="0" cellspacing="0">
            <tr>
              <td>
                <table className="user-data-one hk_bg">
                  <tr>
                    <td className="user-data-td">
                      <h3 className="team-heading">The Ackerman Team</h3>
                      <p className="team-para">
                        7919 Jessles Way, Hamilton, OH, 45011, US
                      </p>
                    </td>
                    <td className="logo-wrap">
                      <img src={Bfilelogo} />
                    </td>
                  </tr>
                </table>

                <table className="user-table-three">
                  <tr>
                    <td>
                      <table className="user-table-four">
                        <tr>
                          <td>
                            <p className="cal-wrap">
                              Intelligence Link
                            </p>
                            <p className="cal-wrap-one">
                              Based on the information we just discussed our
                              Intelligence Link has determined that you
                              need to protect assets in the amount of:
                            </p>
                            <p className="cal-wrap-two">$5,000,000</p>
                          </td>
                        </tr>
                      </table>
                      <table className="user-table-five">
                        <tr>
                          <td>Auto & Home Unit</td>
                        </tr>
                      </table>
                      <table className="user-table-six">
                        <tr>
                          <td className="car-wrap">
                            <img className="car-img" src={Car} alt="" />
                            <p className="auto-para">Auto</p>
                            <p className="num-para">$200,001 - $250,000</p>
                          </td>
                          <td className="user-td-house">
                            <img className="house-wrap" src={House} alt="" />
                            <p className="auto-para">Home</p>
                            <p className="num-para">$200,001 - $250,000</p>
                          </td>
                        </tr>
                      </table>
                      <table className="user-table-seven">
                        <tr>
                          <td>Recommended Umbrella Limit</td>
                        </tr>
                      </table>
                      <table className="user-table-eight">
                        <tr>
                          <td>
                            <img className="um-img" src={Umbrellas} alt="" />
                            <p className="auto-para">Umbrella</p>
                            <p className="num-para">$2,000,000</p>
                          </td>
                        </tr>
                      </table>
                      <table className="user-table-seven">
                        <tr>
                          <td>P & C ITEMS IN THE HOUSEHOLD</td>
                        </tr>
                      </table>
                      <table className="user-table-nine">
                        <tr>
                          <td>
                            <img className="car-img" src={Car} alt="" />
                            <p className="home-wrap">Auto</p>
                          </td>
                          <td>
                            <img className="house-wrap" src={House} alt="" />
                            <p className="home-wrap">Home</p>
                          </td>
                          <td>
                            <img className="bike-wrap" src={Bike} alt="" />
                            <p className="home-wrap">Off Road</p>
                          </td>
                          <td>
                            <img className="um-img" src={Umbrellas} alt="" />
                            <p className="home-wrap">Umbrella</p>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>

                <table className="table-footer" cellspacing="0">
                  <tr>
                    <td></td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div className="hide-print">
          <Card
            className="wizardCard"
            bordered={false}
            title={
              <div>
                <Tag color="#87d068">
                  <Translate text={wizard.status} />
                </Tag>
                <Translate text={`Recommended Liability Limits`} />
              </div>
            }
          >
            <Card style={{ textAlign: "center" }}>
              <div className="right-align">
                <Button onClick={() => Print()}>
                  <Icon type="printer" /> <Translate text={`Print`} />
                </Button>
              </div>

              <h2>
                <Translate text={`Intelligence Link`} />
              </h2>

              <p>
                <Translate
                  text={`Based on the information we just discussed, our Intelligence Link has determined that you need to protect assets in the amount of:`}
                />
              </p>

              <div
                className="racAmount"
                style={{ textAlign: "center", fontSize: 40, marginBottom: 30 }}
              >
                {F.dollar_format(wizard.rac_calculator)}
              </div>

              <h3>
                <Translate text={`Liability Acknowledgement`} />
              </h3>
              <p>
                <Translate
                  text={`(Acknowledges that you understand the results of the Intelligence Link)`}
                />
              </p>
              <p>
                <Translate text={`Acknowledge?`} />
              </p>

              <RadioGroup
                value={wizard.acknowledge}
                onChange={(e) => updateField("acknowledge", e.target.value)}
              >
                <Radio value="1" className="btnYes">
                  <Icon
                    type="like-o"
                    style={{ marginRight: 10, color: "#388E3C" }}
                  />{" "}
                  <Translate text={`Yes`} />
                </Radio>
                <Radio value="0" className="btnNo">
                  <Icon
                    type="dislike-o"
                    style={{ marginRight: 10, color: "#FF3D00" }}
                  />{" "}
                  <Translate text={`No`} />
                </Radio>
              </RadioGroup>
            </Card>
            <Row gutter={40}>
              <Col md={12} span={24}>
                <List
                  itemLayout="horizontal"
                  dataSource={home_list}
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta
                        title={
                          <div className="list-avatar">
                            <Avatar
                              src={item.icon}
                              style={{ marginRight: 10 }}
                            />
                            <Translate text={item.title} />
                          </div>
                        }
                      />
                      <div className="racAmount">{item.value}</div>
                    </List.Item>
                  )}
                />
              </Col>
              <Col md={12} span={24}>
                <List
                  itemLayout="horizontal"
                  dataSource={auto_list}
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta
                        title={
                          <div className="list-avatar">
                            <Avatar
                              src={item.icon}
                              style={{ marginRight: 10 }}
                            />
                            <Translate text={item.title} />
                          </div>
                        }
                      />
                      <div className="racAmount">{item.value}</div>
                    </List.Item>
                  )}
                />
              </Col>

              {wizard.umbrella_limit !== "" && (
                <Col md={24} span={24}>
                  <List
                    itemLayout="horizontal"
                    dataSource={umbrella_list}
                    renderItem={(item) => (
                      <div>
                        <List.Item>
                          <List.Item.Meta
                            title={
                              <div className="list-avatar">
                                <Avatar
                                  src={item.icon}
                                  style={{ marginRight: 10 }}
                                />
                                <Translate text={item.title} />
                              </div>
                            }
                          />
                          <div className="racAmount">
                            {F.dollar_format(item.value)}
                          </div>
                        </List.Item>
                        <div className="message" style={{ marginTop: 10 }}>
                          {item.message}
                        </div>
                      </div>
                    )}
                  />
                </Col>
              )}
            </Row>
          </Card>
          <WizardFooter {...this.props} />
        </div>
      </div>
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/scenes/WizardInvitee/parts/step6.js